<template>
  <div class="agent-area-home">
    <p class="subtitle">
      ברוכים הבאים למסך ניהול המודעות. ניתן לערוך, להקפיץ או למחוק
      מודעות קיימות.
    </p>
    <div class="action_buttons">
      <router-link
					to="/agents-area/locate-vehicle"
			>+ פרסום מודעה חדשה</router-link>
    </div>
		<cars-pagination></cars-pagination>
    <div class="grid">
      <div
				role="button"
				tabindex="0"
        class="car-card"
        v-for="(car, pIndex) in cars"
        :key="pIndex"
        @click="selectCar(car)"
        :class="{
          blur: hoverItem,
          current: selectedCar != null && car.id === selectedCar.id,
        }"
        @mouseover="handleMouseHover(car)"
        @mouseleave="handleMouseLeave()"
      >
        <div class="car-card-image">
          <div class="certificates">
            <ul>
              <li
                v-for="(certificate, pIndex) in car.certificates"
                :key="pIndex"
              >
                {{ certificate.title }}
              </li>
            </ul>
          </div>
          <img v-if="car.thumbnail" :src="car.thumbnail" :alt="car.title" />
        </div>
        <div class="car-card-content">
          <div class="car-card-title">
            <h3>{{ car.title }}</h3>
          </div>
          <div class="car-card-data">
            <div class="block-item">
              <span>שנת יצור</span>
              <span class="value">{{ car.year }}</span>
            </div>
            <div class="block-item">
              <span>ק"מ</span>
              <span class="value">{{ car.km }}</span>
            </div>
            <div class="block-item">
              <span>יד</span>
              <span class="value">{{ car.past_owners }}</span>
            </div>
          </div>
          <div class="prices">
            <div class="block-item">
              <span>מחיר הרכב</span>
              <span class="value">{{ car.price }}</span>
            </div>
            <div class="block-item">
              <span>סוג דלק</span>
              <span class="value">{{ car.fuel }}</span>
            </div>
          </div>
					<div class="car-actions">
						<button type="button" class="send-to-top" @click.stop="sendToTop(car)">הקפצה</button>
						<button type="button" class="delete" @click.stop="deleteCarAction(car)">מחיקה</button>
					</div>
        </div>
      </div>
    </div>
		<cars-pagination></cars-pagination>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import CarsPagination from "@/components/CarsPagination.vue";

export default {
  name: "Home",
	components: {CarsPagination},
  data() {
    return {
      hoverItem: null,
      selectedCar: null
    };
  },
	computed: {
		...mapGetters([
				'cars',
		])
	},
  methods: {
    selectCar(car) {
      /*this.$router.push({
				name: 'car-summary',
				params: {
					id: car.id
				}
			});*/
			this.$router.push({
				name: 'car',
				params: {
					id: car.id
				}
			});
    },
    handleMouseHover(car) {
      this.selectedCar = car
      this.hoverItem = true
    },
    handleMouseLeave() {
      this.selectedCar = null
      this.hoverItem = false
    },
		async deleteCarAction(car){
			if(await this.deleteCar(car)){
				this.$router.push({
					name: 'agents-area'
				})
			}
		},
		async sendToTop(car){
			if(await this.moveCarToTop(car)){
				alert('רכב הוקפץ בהצלחה')
			}
		},
		...mapActions([
				'deleteCar',
				'moveCarToTop',
				'loadCars'
		])
  }
};
</script>
